import React from 'react';
import { getIsOrderBundling } from '~shared/features/checkout/selectors/getCheckoutFlow';
import { useSelectorShared } from '~shared/store';
import { DeliverySummary } from './DeliverySummary';
import { OrderBundlingCheckoutDeliverySummary } from '~web/features/checkout/components/OrderBundlingCheckoutDeliverySummary';

type Props = {
  readonly handleEditCart?: () => void;
};

export const CheckoutDeliverySummary = ({ handleEditCart }: Props) => {
  const isOrderBundling = useSelectorShared(getIsOrderBundling);

  return (
    <div>
      {isOrderBundling ? (
        <OrderBundlingCheckoutDeliverySummary handleEditCart={handleEditCart} />
      ) : (
        <DeliverySummary handleEditCart={handleEditCart} />
      )}
    </div>
  );
};
